// extracted by mini-css-extract-plugin
module.exports = {"login":"index_login_1YHli"};